import React from 'react';
import Icon, { IconKey } from 'flow/components/ui-components/Icon';

interface Props {
    iconKey: IconKey;
    text: string;
}

// Shows the icon on a narrow tab strip (@container < 500px) and the text otherwise.
const TabLabel = ({ iconKey, text }: Props) => (
    <>
        <span className="hidden @max-[500px]:inline-flex">
            <Icon iconKey={iconKey} size="1rem" />
        </span>
        <span className="@max-[500px]:hidden">{text}</span>
    </>
);

export default TabLabel;
